import { useNavigate } from 'react-router';
import { Clock3, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function SocialComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6">
      <section className="rounded-3xl border border-white/15 bg-neutral-950/70 p-8 text-center text-white shadow-[0_20px_60px_rgba(15,23,42,0.4)] backdrop-blur-lg sm:p-10">
        <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full border border-purple-300/50 bg-purple-500/20">
          <Clock3 className="h-6 w-6 text-purple-200" />
        </div>
        <p className="mb-2 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs tracking-wide text-white/85">
          <Sparkles className="h-3.5 w-3.5" />
          Social Media Module
        </p>
        <h1 className="text-2xl font-light sm:text-4xl">Coming Soon</h1>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-white/75 sm:text-base">
          We are temporarily holding social features while we stabilize core experiences. Your Home, Check-In, Timeline,
          Insights, and other sections remain fully available.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            onClick={() => navigate('/home')}
            className="rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 text-white"
          >
            Back to Home
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/settings')}
            className="rounded-2xl border-white/25 bg-white/10 text-white hover:bg-white/20"
          >
            Go to Settings
          </Button>
        </div>
      </section>
    </div>
  );
}
